const CharacterCounter = () => {
    const messageField = document.getElementById('message');
    const charCount = document.getElementById('charCount');
    
    if (!messageField || !charCount) {
        console.warn('Character counter: Required elements not found');
        return;
    }

    // Update character count on input
    const updateCount = () => {
        const currentLength = messageField.value.length;
        charCount.textContent = currentLength;
    };

    // Add event listener to the input
    messageField.addEventListener('input', updateCount);
    
    // Initialize counter on component load
    updateCount();
};

export default CharacterCounter;